/* Product page (Outfitters style) — sections/ref-product.liquid
   Variants, prices and stock come from the product JSON the section prints.
   ADD TO CART posts to /cart/add.js, so the store header shows its own
   "Item added to your cart" message and updates the bag count. */
(() => {
  if (window.__rpdReady) return;
  window.__rpdReady = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* keep the sticky details below a sticky / fixed store header */
  const headerOffset = () => {
    let bottom = 0;
    document.querySelectorAll('header, .ref-header, [data-ref-header], .shopify-section-group-header-group > *').forEach((el) => {
      const cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom < innerHeight / 2) bottom = Math.max(bottom, r.bottom);
    });
    return Math.round(bottom);
  };

  const init = (root) => {
    if (!root || root.dataset.rpdInit === '1') return;
    root.dataset.rpdInit = '1';

    let data;
    try { data = JSON.parse(root.querySelector('[data-rpd-data]').textContent); } catch (_) { return; }
    const variants = data.variants || [];
    const optionCount = variants[0] ? variants[0].options.length : 0;

    const idInput = root.querySelector('[data-rpd-id]');
    const addBtn = root.querySelector('[data-rpd-add]');
    const buyBtn = root.querySelector('[data-rpd-buy]');
    const qtyInput = root.querySelector('[data-rpd-qty-input]');
    /* whatever is typed in the box, what leaves this page is a whole number of at least 1 */
    const qtyOf = () => {
      const n = parseInt(qtyInput && qtyInput.value, 10);
      return n > 0 ? Math.min(n, 999) : 1;
    };
    const addText = root.querySelector('[data-rpd-add-text]');
    const msg = root.querySelector('[data-rpd-msg]');
    const drawer = root.querySelector('[data-rpd-drawer]');
    const track = root.querySelector('[data-rpd-track]');

    /* ---------- options & variants ---------- */
    const startVariant = variants.find((v) => v.id === data.current) || variants[0];
    const chosen = new Array(optionCount).fill(null);
    /* colours (and anything shown as already picked) start selected; sizes wait for the shopper */
    root.querySelectorAll('.rpd__swatch.is-active[data-option], .rpd__size.is-active[data-option]').forEach((b) => { chosen[Number(b.dataset.option)] = b.dataset.rpdValue; });
    if (data.single && startVariant) startVariant.options.forEach((v, i) => { chosen[i] = v; });
    const pickedOrStart = () => chosen.map((v, i) => (v != null ? v : startVariant && startVariant.options[i]));
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const allChosen = () => chosen.every((v, i) => v != null || !root.querySelector(`[data-option="${i}"]`));

    const setMsg = (text) => {
      msg.textContent = text || '';
      msg.hidden = !text;
    };

    const renderPrice = (v) => {
      if (!v) return;
      root.querySelector('[data-rpd-now]').textContent = v.price;
      const was = root.querySelector('[data-rpd-was]');
      const off = root.querySelector('[data-rpd-off]');
      was.hidden = !v.compare;
      off.hidden = !v.compare;
      was.textContent = v.compare || '';
      off.textContent = v.compare ? `${v.off}% OFF` : '';
      const sku = drawer && drawer.querySelector('[data-rpd-sku]');
      if (sku && v.sku && !sku.dataset.fixed) sku.textContent = v.sku;
    };

    /* sold-out values: a value is sold out when no variant with it (and the other picks) can be bought */
    const markStock = () => {
      root.querySelectorAll('.rpd__size[data-option], .rpd__swatch[data-option]').forEach((b) => {
        const i = Number(b.dataset.option);
        const opts = pickedOrStart();
        opts[i] = b.dataset.rpdValue;
        const v = findVariant(opts);
        const soldout = !v || !v.available;
        b.classList.toggle('is-soldout', soldout);
        b.setAttribute('aria-label', `${b.dataset.rpdValue}${soldout ? ' (sold out)' : ''}`);
      });
    };

    /* ---------- photos per colour ----------
       A photo belongs to a colour when its alt text is that colour (Shopify
       admin > photo > alt text) or it is that colour's variant image; photos
       that follow it belong to the same colour until the next colour starts.
       Photos before the first colour photo are shown for every colour. */
    const dots = root.querySelector('[data-rpd-dots]');
    const mediaEls = track ? [...track.children] : [];
    let colourPhotos = false;
    if (data.colorIndex > -1 && mediaEls.length) {
      const colours = [...new Set(variants.map((v) => v.options[data.colorIndex]))];
      const byMedia = {};
      variants.forEach((v) => { if (v.media) byMedia[String(v.media)] = v.options[data.colorIndex]; });
      const norm = (t) => String(t || '').trim().toLowerCase();
      let cur = null;
      mediaEls.forEach((el) => {
        const alt = norm(el.dataset.alt);
        const c = colours.find((x) => norm(x) === alt) || byMedia[el.dataset.mediaId] || null;
        if (c) cur = c;
        if (cur) { el.dataset.color = cur; colourPhotos = true; }
      });
    }
    const renderDots = () => {
      if (!dots) return;
      const n = mediaEls.filter((el) => !el.hidden).length;
      dots.innerHTML = n > 1 ? '<span class="rpd__dot is-active"></span>'.repeat(1) + '<span class="rpd__dot"></span>'.repeat(n - 1) : '';
    };
    const showColour = (colour, animate) => {
      if (!colourPhotos) return;
      let shown = 0;
      mediaEls.forEach((el) => {
        const show = !el.dataset.color || el.dataset.color === colour;
        el.hidden = !show;
        if (show) {
          shown += 1;
          if (animate && !reduced) { el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); }
        }
      });
      /* a colour with no photos of its own: show everything rather than nothing */
      if (!shown) mediaEls.forEach((el) => { el.hidden = false; });
      track.classList.toggle('is-odd', mediaEls.filter((el) => !el.hidden).length === 1);
      track.scrollTo({ left: 0 });
      renderDots();
    };

    const update = (fromUser) => {
      const v = findVariant(pickedOrStart());
      markStock();
      renderPrice(v || startVariant);
      if (!v) {
        addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        addText.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      /* no size picked yet: the button stays usable while any size of this colour can be bought */
      let canBuy = v.available;
      if (!allChosen()) {
        canBuy = variants.some((x) => x.available && x.options.every((o, i) => chosen[i] == null || chosen[i] === o));
      }
      addBtn.disabled = !canBuy;
      if (buyBtn) buyBtn.disabled = !canBuy;
      addText.textContent = canBuy ? 'Add to cart' : 'Sold out';
      if (fromUser) {
        setMsg('');
        if (allChosen()) {
          const u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u);
        }
      }
      return v;
    };

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.rpd__size[data-option], .rpd__swatch[data-option]');
      if (!btn || !root.contains(btn)) return;
      const i = Number(btn.dataset.option);
      chosen[i] = btn.dataset.rpdValue;
      root.querySelectorAll(`[data-option="${i}"]`).forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (btn.classList.contains('rpd__swatch')) {
        const name = root.querySelector('[data-rpd-color-name]');
        if (name) name.textContent = btn.dataset.rpdValue;
        root.querySelectorAll('[data-rpd-meta-color]').forEach((m) => { m.textContent = btn.dataset.rpdValue; });
      }
      update(true);
      if (btn.classList.contains('rpd__swatch') && i === data.colorIndex) showColour(btn.dataset.rpdValue, true);
    });

    update(false);
    if (data.colorIndex > -1) showColour(pickedOrStart()[data.colorIndex], false);

    /* colour squares: when a colour has no swatch set in Shopify and its name is not a
       colour the browser knows (e.g. "Mustard"), use that colour's own photo */
    root.querySelectorAll('.rpd__swatch[data-fallback]').forEach((b) => {
      const span = b.firstElementChild;
      const name = String(b.dataset.rpdValue || '').toLowerCase().replace(/\s+/g, '');
      if (window.CSS && CSS.supports && CSS.supports('color', name)) return;
      span.style.backgroundColor = '';
      span.style.backgroundImage = `url("${b.dataset.fallback}")`;
    });

    /* ---------- product description ----------
       Text pasted from other apps can bring buttons, icons (e.g. a "copy" icon) and
       empty blocks that only add space; those are removed, the text stays. */
    const desc = root.querySelector('.rpd__desc-body');
    if (desc) {
      desc.querySelectorAll('button, svg, input, select, textarea, script, style, form').forEach((el) => el.remove());
      [...desc.querySelectorAll('*')].reverse().forEach((el) => {
        if (el.matches('img, video, iframe, picture, source, br, hr, table *')) return;
        if (!el.textContent.trim() && !el.querySelector('img, video, iframe, picture')) el.remove();
      });
      /* line breaks left at the very end of a block */
      desc.querySelectorAll('br').forEach((br) => {
        let n = br.nextSibling;
        while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
        if (!n) br.remove();
      });
      const blocks = desc.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6, table, div');
      const last = [...blocks].reverse().find((b) => b.textContent.trim() && !b.querySelector('p, ul, ol, div'));
      if (last) last.classList.add('rpd-last');
    }


    /* ---------- add to cart ---------- */
    /* After adding: the store's other cart counts (the phone bottom bar) get the real
       number from Shopify, and the header basket drawer drops its old "empty" view so
       opening it right away never shows a basket that looks empty. */
    const syncCart = () => {
      const dyn = document.querySelector('.ref-cart-dynamic');
      if (dyn && dyn.querySelector('.ref-empty-cart')) {
        dyn.innerHTML = '<div class="ref-cart-loading">Loading cart…</div>';
        document.querySelector('.ref-cart-drawer')?.classList.remove('ref-cart--empty');
      }
      fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          if (!cart) return;
          const n = cart.item_count || 0;
          document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n < 100 ? String(n) : '99+'; });
          document.querySelectorAll('.cart-count-bubble').forEach((el) => el.classList.toggle('is-empty', n === 0));
        })
        .catch(() => {});
    };

    /* Size phone par bhi seedhi page par hai (ADD TO CART ke uper), is liye
       yahan koi sheet nahi kholi jati — jo size chuna hua hai wohi jata hai. */
    const doAdd = async (buy) => {
      const btn = buy && buyBtn ? buyBtn : addBtn;
      if (addBtn.classList.contains('is-busy') || (buyBtn && buyBtn.classList.contains('is-busy'))) return;
      if (addBtn.disabled) return;
      if (!allChosen()) {
        const missing = chosen.findIndex((v, i) => v == null && root.querySelector(`[data-option="${i}"]`));
        const row = root.querySelector(`[data-option="${missing}"]`)?.closest('.rpd__sizes, .rpd__swatches');
        const label = row?.closest('.rpd__row')?.querySelector('.rpd__label')?.textContent.trim().replace(/^select\s+/i, '') || 'size';
        setMsg(`Please select a ${label.toLowerCase()}`);
        if (row && !reduced) { row.classList.remove('is-shake'); void row.offsetWidth; row.classList.add('is-shake'); }
        return;
      }
      setMsg('');
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${ROOT}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qtyOf() }] }),
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.description || body.message || 'Could not add this item.');
        if (buy) {
          /* straight to checkout; the button stays busy while the page leaves */
          location.href = `${ROOT}checkout`;
          return;
        }
        syncCart();
        if (!document.querySelector('.ref-header')) {
          ['cart:refresh', 'cart:updated'].forEach((n) => document.dispatchEvent(new CustomEvent(n, { detail: { item: body } })));
        }
      } catch (err) {
        setMsg(err.message);
      } finally {
        if (!buy) {
          btn.classList.remove('is-busy');
          btn.removeAttribute('aria-busy');
        }
      }
    };
    addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      doAdd(false);
    });
    buyBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      doAdd(true);
    });

    /* ---------- quantity ---------- */
    if (qtyInput) {
      const setQty = (n) => { qtyInput.value = String(Math.min(999, Math.max(1, n))); syncQtyBtns(); };
      const minusBtn = root.querySelector('[data-rpd-qty-step="-1"]');
      function syncQtyBtns() { if (minusBtn) minusBtn.disabled = qtyOf() <= 1; }
      root.querySelectorAll('[data-rpd-qty-step]').forEach((b) => {
        b.addEventListener('click', (e) => {
          e.preventDefault();
          setQty(qtyOf() + Number(b.dataset.rpdQtyStep));
        });
      });
      qtyInput.addEventListener('input', syncQtyBtns);
      qtyInput.addEventListener('change', () => setQty(qtyOf()));
      qtyInput.addEventListener('blur', () => setQty(qtyOf()));
      syncQtyBtns();
    }

    /* ---------- mobile gallery dots ---------- */
    if (dots && track) {
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const first = mediaEls.find((el) => !el.hidden);
          const step = first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
          const i = Math.round(track.scrollLeft / Math.max(1, step));
          [...dots.children].forEach((d, n) => d.classList.toggle('is-active', n === i));
        });
      }, { passive: true });
    }

    /* ---------- sticky offset ---------- */
    const sticky = root.querySelector('[data-rpd-sticky]');
    const setTop = () => { if (sticky) root.style.setProperty('--rpd-top', `${headerOffset()}px`); };
    setTop();
    window.addEventListener('resize', setTop, { passive: true });
    window.addEventListener('scroll', () => { if (!root._rpdTopSet) { root._rpdTopSet = true; setTop(); } }, { passive: true, once: true });

    /* ---------- drawers ---------- */
    if (!drawer) return;
    document.body.appendChild(drawer); /* above the whole page, header included */
    root._rpdDrawer = drawer;
    const panel = drawer.querySelector('.rpd-drawer__panel');
    let lastFocus = null;

    /* ---------- size guide ----------
       Entries come from the product's "Size guide" metafield. Usually one entry per
       size (Name = the size); one entry with a whole table works too. The numbers can
       be typed in almost any layout; CM or INCH is taken from the text ("22 inch",
       "68cm", 27"), else from the entry's "Numbers are in" field (CM if empty). The
       other unit is worked out. */
    const guideJson = drawer.querySelector('[data-rpd-guide]');
    const pills = drawer.querySelector('[data-rpd-guide-pills]');
    const rowsEl = drawer.querySelector('[data-rpd-guide-rows]');
    const emptyEl = drawer.querySelector('[data-rpd-guide-empty]');
    const UNIT_CM = /^(cm|cms|centimet(er|re)s?)$/i;
    const UNIT_IN = /^(in|ins|inch|inches|"|”|''|inchs)$/i;
    const numRe = /(\d+(?:[.,]\d+)?)(?:\s*(cm|cms|centimet(?:er|re)s?|inches|inchs|inch|ins|in|"|”|''))?(?![a-z])/gi;
    const fmt = (x) => {
      if (!Number.isFinite(x)) return '';
      return String(Math.round(x)); /* whole numbers, like the reference */
    };
    const shown = (raw) => String(raw).replace(',', '.').replace(/\.0+$/, '');
    const finish = (label, nums, unitDefault) => {
      if (!label || !nums.length) return null;
      let cm = null; let inch = null;
      nums.filter((n) => n.u === 'cm').forEach((n) => { if (cm == null) cm = n; });
      nums.filter((n) => n.u === 'in').forEach((n) => { if (inch == null) inch = n; });
      const free = nums.filter((n) => !n.u);
      if (free.length >= 2 && cm == null && inch == null) { cm = free[0]; inch = free[1]; }
      else free.forEach((n) => {
        if (unitDefault === 'in' ? inch == null : cm != null) { if (inch == null) inch = n; }
        else if (cm == null) cm = n;
      });
      const cmTxt = cm ? shown(cm.raw) : (inch ? fmt(inch.v * 2.54) : '');
      const inTxt = inch ? shown(inch.raw) : (cm ? fmt(cm.v / 2.54) : '');
      return { label, cm: cmTxt, inch: inTxt };
    };
    const unitOf = (t) => (UNIT_IN.test(String(t || '').trim()) || /inch/i.test(String(t || '')) ? 'in' : 'cm');
    const numbersIn = (text) => {
      const out = [];
      String(text).replace(numRe, (m, n, u) => {
        out.push({ raw: n, v: parseFloat(n.replace(',', '.')), u: u ? (UNIT_CM.test(u) ? 'cm' : 'in') : '' });
        return m;
      });
      return out;
    };
    const labelOf = (line) => line
      .replace(numRe, ' ')
      .replace(/\b(cm|cms|inch|inches|in)\b/gi, ' ')
      .replace(/[|:=\-–—\/,;()*•]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    /* one size: label + numbers, on one line or spread over the next lines */
    const parseSize = (text, unit) => {
      let ctx = unit;
      const rows = [];
      let label = null; let nums = [];
      const flush = () => { const r = finish(label, nums, ctx); if (r) rows.push(r); label = null; nums = []; };
      String(text || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean).forEach((line) => {
        const bare = line.replace(/[()\[\]:]/g, '').trim();
        if (UNIT_CM.test(bare) || UNIT_IN.test(bare)) { ctx = UNIT_CM.test(bare) ? 'cm' : 'in'; return; }
        const lab = labelOf(line);
        const ns = numbersIn(line);
        if (/[a-z]/i.test(lab)) {
          if (/^measurements?$/i.test(lab) && !ns.length) return;
          flush();
          label = lab;
          nums = ns;
          if (ns.length) flush();
        } else if (ns.length && label) {
          nums.push(...ns);
        }
      });
      flush();
      return rows;
    };
    /* a whole table: first line = sizes, then "label | value | value ..." */
    const parseTable = (text, unit) => {
      const lines = String(text || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
      const cut = (l) => l.split(/\s*(?:\||\t|;)\s*/).map((c) => c.trim());
      if (lines.length < 2) return null;
      const head = cut(lines[0]);
      if (head.length < 3) return null;
      const sizes = head.slice(1).filter(Boolean);
      const map = {};
      sizes.forEach((sz) => { map[sz] = []; });
      lines.slice(1).forEach((l) => {
        const cells = cut(l);
        const label = labelOf(cells[0]);
        if (!label) return;
        sizes.forEach((sz, n) => {
          const cell = cells[n + 1] || '';
          const parts = cell.split('/');
          let nums = numbersIn(parts[0]);
          if (parts[1] != null) nums = nums.concat(numbersIn(parts[1]).map((x) => ({ ...x, u: x.u || 'in' })));
          if (parts[1] != null && nums[0] && !nums[0].u) nums[0].u = 'cm';
          const r = finish(label, nums, unit);
          if (r) map[sz].push(r);
        });
      });
      return { sizes, map };
    };
    let guide = null;
    if (guideJson && pills && rowsEl) {
      let entries = [];
      try { entries = JSON.parse(guideJson.textContent) || []; } catch (_) {}
      const sizes = [];
      const map = {};
      entries.forEach((en) => {
        const unit = unitOf(en.unit);
        const text = en.text || '';
        const firstLine = text.split(/\r?\n/).find((l) => l.trim()) || '';
        const table = /[|\t;]/.test(firstLine) && firstLine.split(/\s*(?:\||\t|;)\s*/).filter(Boolean).length >= 3 ? parseTable(text, unit) : null;
        if (table) {
          table.sizes.forEach((sz) => { if (!map[sz]) sizes.push(sz); map[sz] = table.map[sz]; });
        } else {
          const name = String(en.name || '').trim() || `Size ${sizes.length + 1}`;
          if (!map[name]) sizes.push(name);
          map[name] = parseSize(text, unit);
        }
      });
      /* same order as the sizes on the product */
      const productSizes = data.sizeIndex > -1 ? [...new Set(variants.map((v) => v.options[data.sizeIndex]))] : [];
      const rank = (sz) => { const i = productSizes.findIndex((p) => p.toLowerCase() === sz.toLowerCase()); return i < 0 ? 999 : i; };
      sizes.sort((x, y) => rank(x) - rank(y));
      if (sizes.length) guide = { sizes, map };
    }
    let guideSize = 0;
    const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const renderGuide = (animate) => {
      if (!guide) return;
      pills.innerHTML = guide.sizes.map((sz, n) => `<button class="rpd-pill${n === guideSize ? ' is-active' : ''}" type="button" role="radio" data-guide-size="${n}" aria-checked="${n === guideSize}">${esc(sz)}</button>`).join('');
      const rows = guide.map[guide.sizes[guideSize]] || [];
      rowsEl.innerHTML = '';
      rows.forEach((r) => {
        const tr = document.createElement('tr');
        [r.label, r.cm, r.inch].forEach((t, n) => {
          const td = document.createElement('td');
          td.textContent = t;
          if (animate && n) td.className = 'is-swap';
          tr.appendChild(td);
        });
        rowsEl.appendChild(tr);
      });
      if (emptyEl) emptyEl.hidden = rows.length > 0;
    };
    pills?.addEventListener('click', (e) => {
      const b = e.target.closest('[data-guide-size]');
      if (!b) return;
      guideSize = Number(b.dataset.guideSize);
      renderGuide(true);
    });

    const open = (name) => {
      const pane = drawer.querySelector(`[data-rpd-pane="${name}"]`);
      if (!pane) return;
      drawer.querySelectorAll('[data-rpd-pane]').forEach((p) => { p.hidden = p !== pane; });
      if (name === 'guide' && guide) {
        /* start on the size picked on the page, like the reference */
        const picked = data.sizeIndex > -1 ? chosen[data.sizeIndex] : null;
        const n = picked ? guide.sizes.findIndex((s) => s.toLowerCase() === String(picked).toLowerCase()) : -1;
        guideSize = n > -1 ? n : 0;
        renderGuide(false);
      }
      lastFocus = document.activeElement;
      drawer.hidden = false;
      panel.scrollTop = 0;
      document.documentElement.classList.add('rpd-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
      panel.focus({ preventScroll: true });
    };
    const close = () => {
      if (drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('rpd-lock');
      setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, reduced ? 0 : 450);
      lastFocus?.focus?.({ preventScroll: true });
    };
    root._rpdClose = close;
    root._rpdOpen = open;

    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rpd-open]');
      if (b) { e.preventDefault(); open(b.dataset.rpdOpen); }
    });
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-rpd-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  };

  /* Phones: the store header is see-through over the first photo while the page is
     at the very top (the section marks it .ref-header--clear). The header script
     paints its bar white inline, so the bar is kept clear here until it scrolls. */
  const clearHeader = () => {
    const head = document.querySelector('.ref-header.ref-header--clear');
    const bar = head && head.querySelector('.ref-header__bar');
    if (!bar || head.dataset.rpdClear === '1') return;
    head.dataset.rpdClear = '1';
    const phone = window.matchMedia('(max-width: 767px)');
    const apply = () => {
      const on = phone.matches && !head.classList.contains('ref-scroll-sticky') && !head.classList.contains('ref-header--transparent');
      if (on && bar.style.getPropertyValue('background-color') !== 'transparent') bar.style.setProperty('background-color', 'transparent', 'important');
    };
    new MutationObserver(apply).observe(bar, { attributes: true, attributeFilter: ['style'] });
    new MutationObserver(apply).observe(head, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', apply, { passive: true });
    apply();
  };
  clearHeader();

  document.querySelectorAll('[data-rpd]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-rpd]').forEach(init));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-rpd]').forEach((root) => {
      root._rpdDrawer?.remove();
      document.documentElement.classList.remove('rpd-lock');
    });
  });
})();
